import {
  Accordion,
  AccordionItem,
  AccordionButton,
  AccordionPanel,
  AccordionIcon,
  Box,
  Heading,
} from "@chakra-ui/react";

const FAQ = ({ title, message }) => {
  return (
    <AccordionItem border="0">
      <h2>
        <AccordionButton>
          <Box flex="1" textAlign="left">
            {title}
          </Box>
          <AccordionIcon />
        </AccordionButton>
      </h2>
      <AccordionPanel pb={4}>{message}</AccordionPanel>
    </AccordionItem>
  );
};

const FAQs = () => {
  const accordionItems = [
    {
      title: "how do I know if any of my wishes has been fulfilled ?",
      message: "some message",
    },
    { title: "Does a PromiseCard expire ?", message: "some message" },
    {
      title: "How do i recieve promises like bags and shoes?",
      message: "some message",
    },
    {
      title: "Can I share my promise card  on social media?",
      message: "some message",
    },
    {
      title: "Is there a reward for referring friends and family",
      message: "some message",
    },
    {
      title: "Is there a maximum amount of wishes for a promise card ?",
      message: "some message",
    },
    { title: "What if my wishes don get fulfilled ?", message: "some message" },
    {
      title: "Is there a charge for using promiseCard ?",
      message: "some message",
    },
    {
      title: "How safe are my fiulfilled wishes on PromiseCard ?",
      message: "some message",
    },
  ];
  return (
    <Box bg="rgba(96, 39, 173, 5%)" p="2rem" borderRadius=".5rem">
      <Heading textAlign="center" fontWeight="600" size="2xl">
        Frequently Asked Questions
      </Heading>

      <Accordion defaultIndex={[0]}>
        {accordionItems.map((item) => {
          return <FAQ title={item.title} message={item.message} />;
        })}
      </Accordion>
    </Box>
  );
};

export default FAQs;
